import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setToast } from "../../../../app/appSlice";
import {
  IDomaine,
  useExistDomaineMutation,
  useUpdateDomaineMutation,
} from "../../cdsApiSlice";
import { extendedApi } from "../../cdsApiSlice";
import styles from "./domaineManagement.module.scss";


interface IUpdateDoamin {
  setter: () => void;
  udpate: () => void;
  errorDialog: boolean;
  domaine: IDomaine;
}

const UpdateDomain = ({
  setter,
  errorDialog,
  udpate,
  domaine,
}: IUpdateDoamin) => {
  const [libelle, setLibelle] = useState<string>(domaine.libelle);
  const [description, setDescription] = useState<string>(domaine.description);
  const dispatch = useDispatch();
  const [updateDomaine, updateDomaineStatus] = useUpdateDomaineMutation();
  const [getExistDoamine, { data: dataExistDomaine, ...DataStatus }] =
    useExistDomaineMutation();

  const handleSubmit = async () => {
    try {
      updateDomaine({ domaine: { ...domaine, libelle, description } }).unwrap()
      dispatch(
        setToast({
          title: "Modification de domaine",
          severity: "success",
          life: 3000,
          content: `Domaine ${libelle} modifié !`,
        })
      );
      // code KO suite update redux, - mais on utilise plus le CDS de datapipeline-ui
      /*dispatch(
        extendedApi.util.updateQueryData("domaines", undefined, (draft) => {
          for (let d of draft.data) {
            if (d.id === domaine.id) {
              d = { ...domaine, libelle, description };
              break;
            }
          }
          return draft;
        })
      );*/
      setter();
    } catch {
      dispatch(
        setToast({
          title: "Modification de domaine",
          severity: "error",
          life: 3000,
          content: `Echec de la modification du domaine ${domaine.libelle} !`,
        })
      );
    }
  };



  const sameDomaine = ():boolean => {
    return libelle.toLocaleLowerCase() !== domaine.libelle.toLocaleLowerCase() 
  }

  const footerDialog = () => {
    return (
      <>
        <Button
          label={"ANNULER"}
          disabled={false}
          onClick={() => setter()}
          className="mr-3 p-button-outlined p-button-sm"
        />

        <Button
          id="hook-form"
          onClick={() => {
            handleSubmit();
          }}
          disabled={libelle === "" || (dataExistDomaine === 1 && sameDomaine()) ? true : false} // if domaine name is empty or already exist disable button
          type="submit"
          label={"MODIFIER"}
          className="p-button p-button-sm"
        >
          {updateDomaineStatus.isLoading ? (
            <FontAwesomeIcon className="ml-2" icon="spinner" spin />
          ) : null}
        </Button>
      </>
    );
  };

  return (
    <>
      <Dialog
        header={`Modifier un domaine`}
        footer={footerDialog}
        visible={errorDialog}
        style={{ width: "25vw" }}
        modal
        onHide={() => {
          setter();
        }}
      >
        <div>
        <div className="titleList">Libellé*</div>
        <div className="mb-2">
          <InputText
            value={libelle}
            onChange={(e) => {
              setLibelle(e.target.value);
              getExistDoamine({ value: e.target.value });
            }}
            className="w-full"
          />
          {/* if domaine already exist, display message to inform a user */}
          {dataExistDomaine === 1 && sameDomaine() ? <div style={{color:"red"}}>domaine {libelle} existe déjà</div> : null}  
        </div>
        <div className="titleList">Description</div>
        <div className="mb-2">
          <InputTextarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full"
          />
        </div>

        {/* <div className="titleList mr-2">Zone</div>
        <div>
          <InputText value={domaine.zone} className="w-full" disabled={true} />
        </div> */}
        </div>
        
      </Dialog>
    </>
  );
};

export default UpdateDomain;
